import {useQuery} from 'react-query'

async function getTeachersOnline(token)
{
    const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/admin/teachers/isonline`,{
        headers:{
            "Authorization":token
        }
    })
    return response.json()
}

export const useAdminTeachersOnline = (token)=>
{
    return useQuery('get-admin-teachers',()=>getTeachersOnline(token))
}